import l from "./ghl-ui.es409.js";
import u from "./ghl-ui.es1468.js";
function h(d) {
  return l(function(i, e) {
    var f = -1, n = e.length, t = n > 1 ? e[n - 1] : void 0, r = n > 2 ? e[2] : void 0;
    for (t = d.length > 3 && typeof t == "function" ? (n--, t) : void 0, r && u(e[0], e[1], r) && (t = n < 3 ? void 0 : t, n = 1), i = Object(i); ++f < n; ) {
      var a = e[f];
      a && d(i, a, f, t);
    }
    return i;
  });
}
export {
  h as default
};
